import request from '@/axios'

export function getHomeData(data) {
  return request({
    url: '/?c=CompanyInterface&m=home_scroll',
    method: 'post',
    params: data
  })
}

export function tijian(data) {
  return request({
    url: '/?c=CompanyInterface&m=info_fen&name='+data,
    method: 'get',
  })
}

export function submitXinyongInfo(data) {
  return request({
    url: '/?c=CompanyInterface&m=info_upload',
    method: 'post',
    params: data
  })
}



